export type FusaToast = {
  header: string;
  message: string;
  link?: string;
  linkText?: string;
  file?: string;
  /** Shown behind a Show details toggle, e.g. a stack trace. */
  details?: string;
  type: FusaToastType;
  autohide?: boolean;
};

export enum FusaToastType {
  ERROR = 'danger',
  SUCCESS = 'success',
  WARNING = 'warning',
}